<template>
  <div class="reward-program-rules">
    <section class="reward-program-rules-card">
      <h2 class="title is-4">{{ $t("rewardProgram.overviewTitle") }}</h2>
      <p>
        {{ $t("rewardProgram.overviewDescription") }}
      </p>

      <div class="reward-program-formula">
        {{ $t("rewardProgram.formula") }}
      </div>
    </section>

    <section class="reward-program-rules-card">
      <h2 class="title is-4">{{ $t("rewardProgram.levelsTitle") }}</h2>

      <div class="reward-program-badges-grid">
        <article
          v-for="level in levels"
          :key="level.name"
          class="reward-program-badge-card"
        >
          <img
            :src="level.badge"
            :alt="`Badge ${level.label}`"
            class="reward-program-badge-image"
          />

          <h3 class="title is-5">{{ level.label }}</h3>
          <p class="reward-program-badge-rate">{{ level.rate }}</p>
          <p class="reward-program-badge-range">{{ level.range }}</p>
        </article>
      </div>
    </section>

    <section class="reward-program-rules-card">
      <h2 class="title is-4">{{ $t("rewardProgram.pointsAccrualTitle") }}</h2>
      <p>
        {{ $t("rewardProgram.pointsAccrualDescription1") }}
        <b>{{ $t("rewardProgram.netRevenueLabel") }}</b>
        {{ $t("rewardProgram.pointsAccrualDescription2") }}
      </p>
    </section>

    <div class="columns is-multiline reward-program-rules-grid">
      <div class="column is-12-tablet is-6-desktop">
        <section class="reward-program-rules-card full-height">
          <h2 class="title is-4">
            {{ $t("rewardProgram.quarterlyClassificationTitle") }}
          </h2>
          <p>
            {{ $t("rewardProgram.quarterlyClassificationDescription1") }}
            <b>{{ $t("rewardProgram.grossRevenueLabel") }}</b>
            {{ $t("rewardProgram.quarterlyClassificationDescription2") }}
          </p>
          <p>{{ $t("rewardProgram.quarterlyClassificationDescription3") }}</p>
        </section>
      </div>

      <div class="column is-12-tablet is-6-desktop">
        <section class="reward-program-rules-card full-height">
          <h2 class="title is-4">
            {{ $t("rewardProgram.levelUpBonusTitle") }}
          </h2>
          <p>
            {{ $t("rewardProgram.levelUpBonusDescription") }}
          </p>
          <p class="reward-program-bonus">
            {{ $t("rewardProgram.levelUpBonusValue") }}
          </p>
          <ul>
            <li>
              {{ $t("rewardProgram.levelUpBonusRule") }}
            </li>
          </ul>
        </section>
      </div>

      <div class="column is-12">
        <section class="reward-program-rules-card reward-program-sults-card">
          <div>
            <h2 class="title is-4">
              {{ $t("rewardProgram.redemptionRequestTitle") }}
            </h2>
            <p>
              {{ $t("rewardProgram.redemptionRequestDescription") }}
            </p>
          </div>

          <a
            class="button is-primary reward-program-sults-button"
            href="https://minhaquitandinha.sults.com.br/login"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $t("rewardProgram.redemptionRequestButton") }}
          </a>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import badgeStart from "../../assets/img/badges/badge-start.png";
import badgeSilver from "../../assets/img/badges/badge-silver.png";
import badgeGold from "../../assets/img/badges/badge-gold.png";
import badgePlatinum from "../../assets/img/badges/badge-platinum.png";
import badgeDiamond from "../../assets/img/badges/badge-diamond.png";
import badgeBlack from "../../assets/img/badges/badge-black.png";
import badgeInfinity from "../../assets/img/badges/badge-infinity.png";

export default {
  computed: {
    levels() {
      return [
        {
          name: "start",
          label: "Start",
          rate: "0%",
          range: this.$t("rewardProgram.levelRanges.start"),
          badge: badgeStart
        },
        {
          name: "silver",
          label: "Silver",
          rate: "1%",
          range: this.$t("rewardProgram.levelRanges.silver"),
          badge: badgeSilver
        },
        {
          name: "gold",
          label: "Gold",
          rate: "1,6%",
          range: this.$t("rewardProgram.levelRanges.gold"),
          badge: badgeGold
        },
        {
          name: "platinum",
          label: "Platinum",
          rate: "2%",
          range: this.$t("rewardProgram.levelRanges.platinum"),
          badge: badgePlatinum
        },
        {
          name: "diamond",
          label: "Diamond",
          rate: "2,6%",
          range: this.$t("rewardProgram.levelRanges.diamond"),
          badge: badgeDiamond
        },
        {
          name: "black",
          label: "Black",
          rate: "3,2%",
          range: this.$t("rewardProgram.levelRanges.black"),
          badge: badgeBlack
        },
        {
          name: "infinity",
          label: "Infinity",
          rate: "5%",
          range: this.$t("rewardProgram.levelRanges.infinity"),
          badge: badgeInfinity
        }
      ];
    }
  }
};
</script>

<style scoped>
.reward-program-rules {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.reward-program-rules-card {
  padding: 1.5rem;
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 2px 10px rgba(10, 10, 10, 0.06);
}

.reward-program-formula {
  margin-top: 1rem;
  padding: 1rem 1.25rem;
  border-radius: 6px;
  background: linear-gradient(135deg, #fff4ee 0%, #fff9f5 100%);
  border: 1px solid #f3c2b5;
  color: #a33e22;
  font-size: 1.05rem;
  font-weight: 700;
}

.reward-program-badges-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1rem;
}

.reward-program-badge-card {
  text-align: center;
  padding: 1.25rem 1rem;
  border: 1px solid #ececec;
  border-radius: 6px;
  background-color: #fafafa;
}

.reward-program-badge-image {
  width: 92px;
  height: 92px;
  object-fit: contain;
  margin-bottom: 0.75rem;
}

.reward-program-badge-rate {
  font-size: 1.35rem;
  font-weight: 800;
  color: #f0512d;
}

.reward-program-badge-range {
  color: #5f5f5f;
  line-height: 1.45;
}

.reward-program-bonus {
  font-size: 1.65rem;
  font-weight: 800;
  color: #219653;
}

.full-height {
  height: 100%;
}

.reward-program-sults-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.reward-program-sults-button {
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .reward-program-sults-card {
    align-items: flex-start;
    flex-direction: column;
  }
}

ul {
  margin-bottom: 0;
}
</style>
